import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import { FormControl, FormLabel, InputAdornment, TextField } from '@mui/material'
import { inputSizes, inputTypes } from '../../constants/input'

const InputFieldV2 = ({
  name,
  type,
  control,
  errors,
  size,
  placeholder,
  startIcon,
  endIcon,
  label,
  defaultValue,
  maxLength,
  sx,
  sxFC,
  sxFL,
  props,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <FormControl
          fullWidth
          sx={{
            mb: 1,
            ...sxFC,
          }}
        >
          <FormLabel
            htmlFor={name}
            sx={{
              ...sxFL,
            }}
          >
            {label}
          </FormLabel>
          <TextField
            {...field}
            id={name}
            type={type}
            size={size}
            placeholder={placeholder}
            fullWidth
            inputProps={{
              maxLength: maxLength,
            }}
            onChange={(e) => {
              if (name === 'nik' || name === 'phone' || type === 'number') {
                field.onChange(e.target.value.replace(/[^0-9]/g, ''))
              } else {
                field.onChange(e.target.value)
              }
            }}
            onKeyDown={(e) => {
              if (type === 'number') {
                if (['e', 'E', '+', '-', '.'].includes(e.key)) {
                  e.preventDefault()
                }
              }
              if (props?.onKeyDown) {
                props.onKeyDown(e)
              }
            }}
            InputProps={{
              ...(startIcon && {
                startAdornment: <InputAdornment position="start">{startIcon}</InputAdornment>,
              }),
              ...(endIcon && {
                endAdornment: <InputAdornment position="end">{endIcon}</InputAdornment>,
              }),
            }}
            error={!!errors[name]}
            helperText={errors[name] && errors[name].message}
            sx={{ ...sx }}
            {...props}
          />
        </FormControl>
      )}
    />
  )
}

InputFieldV2.defaultProps = {
  size: 'large',
  label: 'Input Label',
  placeholder: 'Input something...',
  defaultValue: '',
}

InputFieldV2.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.any.isRequired,
  errors: PropTypes.any.isRequired,
  label: PropTypes.string,
  size: PropTypes.oneOf(inputSizes),
  type: PropTypes.oneOf(inputTypes),
  placeholder: PropTypes.string,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
}

export default InputFieldV2
